import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SelectComponent } from '../../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CurrencyPipe } from '@angular/common';

@Component({
    selector: 'app-taxa-operadora',
    templateUrl: './taxa-operadora.component.html',
    styleUrls: ['./taxa-operadora.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SelectComponent, NgxPaginationModule, CurrencyPipe]
})
export class TaxaOperadoraComponent {

  @Input() dadosTaxasOperadoras : any;
  public taxasPorPagina: number = 5;
  public paginaTaxas: number = 1;

  constructor() {
  }

  onTaxasPorPaginaChange (newTotalItems : number) {
    this.taxasPorPagina = newTotalItems;
    this.paginaTaxas = 1;
  }
}
